import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchBaseQueryWithAuth } from '@utils/api';
import { TAGS as AUTOMATED_DELIVERIES_TAGS } from './AutomatedDeliveries/slice/tags';
import { TAGS as CAMPAIGN_ANALYTICS_TAGS } from './Dashboard/CampaignAnalytics/slice/tags';
import { TAGS as LEGACY_CAMPAIGNS_TAGS } from './Dashboard/dashboardSlice/tags';
import { TAGS as REPORT_RESULTS_TAGS } from './ReportResults/slice/tags';
import { TAGS as LEGACY_ADMIN_TAGS } from './Stats/slice/tags';
import { TAGS as FLEXIBLE_REPORTS_TAGS } from '@features/flexible-reports/slice/tags';
import { TAGS as CAMPAIGNS_API_TAGS } from '../features/campaigns/subdomains/visitation';
import { TAGS as FEATURE_FLAG_TAGS } from '../features/feature-flags/api/tags';
import { TAGS as CPG_REPORT_TAGS } from '../features/campaigns/subdomains/cpg/api/tags';

export const rootApi = createApi({
  reducerPath: 'rootApi',
  baseQuery: fetchBaseQueryWithAuth({
    baseUrl: '',
  }),
  tagTypes: [
    ...AUTOMATED_DELIVERIES_TAGS,
    ...CAMPAIGN_ANALYTICS_TAGS,
    ...Object.values(LEGACY_CAMPAIGNS_TAGS),
    ...REPORT_RESULTS_TAGS,
    ...LEGACY_ADMIN_TAGS,
    ...FLEXIBLE_REPORTS_TAGS,
    ...CAMPAIGNS_API_TAGS,
    ...FEATURE_FLAG_TAGS,
    ...CPG_REPORT_TAGS,
  ],
  endpoints: builder => ({
    getInitialSetup: builder.query<Settings, void>({
      query: () => '/api/initial_setup',
    }),
  }),
});

export const { useGetInitialSetupQuery } = rootApi;
